{
  "nav": {
    "toggleMenu": "Toggle navigation menu",
    "mainNavigation": "Main navigation",
    "moderatorNavigation": "Moderator navigation"
  },
  "b2bNav": {
    "dashboard": "Dashboard",
    "productService": "Product/Service Management",
    "requests": "Requests",
    "matchResults": "Match Results",
    "opportunities": "Opportunities",
    "readiness": "Export Readiness",
    "trustCompliance": "Trust & Compliance",
    "dutyEstimate": "Duty & Tax Estimate",
    "marketIntelligence": "Market Intelligence",
    "messages": "Messages",
    "contracts": "Contracts",
    "profile": "Profile",
    "planUsage": "Plan & Usage"
  },
  "moderatorNav": {
    "dashboard": "Dashboard",
    "companies": "Companies",
    "verification": "Verification",
    "kyb": "KYB",
    "deals": "Deals",
    "coordinator": "Coordinator queue",
    "contracts": "Contracts",
    "conversations": "Conversations",
    "productFeedback": "Product Feedback",
    "hsClassifier": "HS classifier",
    "dutyEstimate": "Duty & tax estimate",
    "articles": "Articles",
    "leadSources": "Lead Sources",
    "readiness": "Readiness",
    "matching": "Matching",
    "pipelineRuns": "Pipeline Runs",
    "moderators": "Moderators",
    "analytics": "Analytics",
    "billing": "Billing",
    "profile": "Profile"
  },
  "notifications": {
    "title": "Notifications",
    "titleWithUnread": "Notifications ({{count}} unread)",
    "list": "Notifications list",
    "markAllRead": "Mark all as read",
    "loading": "Loading notifications...",
    "empty": "No notifications",
    "fallbackTitle": "Notification",
    "viewAll": "View all notifications →"
  },
  "moderator": {
    "logoMark": "MOD",
    "console": "Moderator Console",
    "openProfile": "Open my profile",
    "roleWithProfileLink": "{{role}} · View profile",
    "roles": {
      "super": "Super moderator",
      "moderator": "Moderator"
    },
    "signOut": "Sign out"
  },
  "userMenu": {
    "label": "User menu",
    "guest": "Guest User",
    "myProfile": "My Profile",
    "logout": "Logout",
    "loggingOut": "Logging out..."
  }
}
